module.exports = __webpack_public_path__ + "img/12.d175ff8e.png";